<template>
  <div>
    <SideBar></SideBar>
    <div class="banner"></div>
    <div class="main">
      <div class="path"></div>
      <Breadcrumb class="bread"
                  separator=">">
        <!-- <BreadcrumbItem to="/">
          <img class="bread-icon"
               src="../assets/images/icon-location.png" />首页
        </BreadcrumbItem> -->
        <!--<BreadcrumbItem class="bread-last">服务案例</BreadcrumbItem>-->
      </Breadcrumb>
      <!-- <Bread class="bread"></Bread>   -->
      <Search class="search"
              @searchResult="searchResult" />
      <!-- <router-view></router-view> -->
      <SuccessCaseList :pageVal="pageVal"></SuccessCaseList>
    </div>
  </div>
</template>
<script>
// import Bread from '@/components/Bread.vue';
import SideBar from "@/components/SideBar"
import * as apis from '@/api/success';
import Search from '@/components/SearchOfCase.vue'
import SuccessCaseList from '@/views/SuccessCaseList.vue'
export default {

  data () {
    return {
      accord: '0',
      menus: [],
      pageVal: {
        disease_id: 0,
        type_id: 0,
        id: 0
      }
    }
  },
  components: {
    // Bread
    SideBar,
    Search,
    SuccessCaseList
  },
  mounted () {
    // this.getSuccessLeftMenu();
  },
  methods: {
    async getSuccessLeftMenu () {
      try {
        let res = await apis.getSuccessMenu({});
        if (res.code == 200) {
          this.menus = res.data;
        }
      } catch (e) {
        console.log(e);
      }
    },
    searchResult (val) {
      this.pageVal = val
    }
  }
}
</script>
<style lang="less" scoped>
.banner {
  height: 250px;
  background: url('../assets/images/successCase/banner.png') no-repeat center;
}
.main {
  width: 980px;
  margin: 0 auto 50px;
}
.bread {
  margin: 50px auto 30px;
}
.left-menu {
  // width: 286px;
  width: 100%;
  background-image: url('../assets/images/successCase/icon-bar.jpg');
  background-color: #fff;
  background-repeat: no-repeat;
  background-position: left top;
  border: 1px solid #dcdcdc;
  box-sizing: border-box;
  padding-top: 10px;
}
.left-menu-title {
  width: 210px;
  font-size: 22px;
  color: #ae1e10;
  line-height: 30px;
  background: url('../assets/images/successCase/icon-case.png') no-repeat left
    center;
  padding-left: 38px;
  box-sizing: border-box;
  margin: 18px auto 42px;
}
.submenu {
  font-size: 18px;
  color: #333130;
  line-height: 50px;
  border-bottom: 1px solid #f6f6f6;
  padding-left: 20px;
  a {
    display: block;
    color: #333130;
  }
  .router-link-active {
    background: url('../assets/images/successCase/icon-pointer.png') no-repeat
      150px center;
  }
}
</style>
<style>
.ivu-collapse-content {
  padding: 0;
}
.ivu-collapse-content > .ivu-collapse-content-box {
  padding: 0;
}
.ivu-collapse > .ivu-collapse-item > .ivu-collapse-header {
  height: 60px;
  font-size: 24px;
  color: #ae1e10;
  line-height: 60px;
}
.ivu-collapse-header .ivu-icon {
  float: right;
  margin-top: 6px;
}
</style>

